export default __webpack_public_path__ + "static/media/histogram-blue.c8d153d5.svg";